import React from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';
import routes from '~/apiRouter';
// import Input from '~c/ui/Input';
import InputPhone from '~c/ui/InputPhone';
import messages from '~h/messages';
import Loader, { spinnerStates, spinnerPositions } from '~c/ui/Loader';
import PassRestoration from '~c/popups/PassRestoration';

// Metrika
// import metrikaId from '~/helpers/metrika';
import metrikaGoal from '~/helpers/metrikaGoal';
import PopupClose from '../Close';

class Auth extends React.Component {
  // state = {
  //   phone: '',
  //   password: '',
  //   errorMessage: '',
  //   spinnerState: spinnerStates.done,
  // };

  // constructor(props) {
  //   super(props);
  //   this.redirectParameters = this.props.redirectParameters;
  // }

  // componentDidMount() {
  //   metrikaGoal('userreg-open-popup');
  // }

  // onAuth = e => {
  //   e.preventDefault();

    // FIXE: hardcoded cookie
    // const cookies =
    //   'PHPSESSID=88190c5743c410dd2e247b970cc8db68; BITRIX_SM_LOGIN=admin; BITRIX_SM_SOUND_LOGIN_PLAYED=Y';

    // localStorage.setItem('token', `Basic ${btoa(`${this.state.phone}:${this.state.password}`)}`); // ducker.TODO закоментировать при слитии

  //   const options = {
  //     method: 'POST',
  //     credentials: 'include',
  //     headers: {
  //       // cookie: cookies,
  //       'content-type': 'application/json',
  //     },
  //     body: JSON.stringify({
  //       LOGIN: this.state.phone,
  //       PASSWORD: this.state.password,
  //     }),
  //   };

  //   this.setState({
  //     errorMessage: '',
  //     spinnerState: spinnerStates.pending,
  //   });

  //   fetch(routes.user.auth, options)
  //     .then(response => {
  //       return response.json();
  //     })
  //     .then(json => {
  //       if (json.status === 'success') {
  //         this.setState({
  //           spinnerState: spinnerStates.done,
  //         });

  //         this.props.onAuthCallback();
  //         if (this.props.onAuthLocation !== '') {
  //           window.location.replace(`${this.props.onAuthLocation}?${this.redirectParameters}`);
  //         }
  //       }
  //       if (json.status === 'error') {
  //         this.setState({
  //           errorMessage: json.errors[0].message,
  //           spinnerState: spinnerStates.done,
  //         });
  //       }
  //     })
  //     .catch(() => {
  //       this.setState({
  //         errorMessage: messages.serverTimeout,
  //         spinnerState: spinnerStates.done,
  //       });
  //     });
  // };

  // onRestorationClick = e => {
  //   e.preventDefault();

  //   const { phone } = this.state;
  //   const { onRegCompliteLocation } = this.props;

  //   $.magnificPopup.close();
  //   setTimeout(() => {
  //     $.magnificPopup.open({
  //       removalDelay: 250,
  //       mainClass: 'mfp-anim',
  //       closeOnBgClick: false,
  //       items: {
  //         src: $('#popup'),
  //         type: 'inline',
  //       },
  //       callbacks: {
  //         open() {
  //           render(
  //             <PassRestoration
  //               phone={phone}
  //               onRegCompliteLocation={onRegCompliteLocation}
  //             />,
  //             $('#popup')[0],
  //           );
  //         },
  //         close() {
  //           render(<div />, $('#popup')[0]);
  //         },
  //       },
  //     });
  //   }, 500);
  // };

  render() {
    return (
      // <React.Fragment>
      //     <div className="popup auth">
      //       <div className="header__top">
      //         <div className="container header__container">
      //           <div className="header__logo header-logo">
      //             <a className="header-logo__link" href="/">
      //               {' '}
      //               {/*<img src="static/img/logo.svg" alt="logo" />*/}
      //             </a>
      //             <h4 className="header-logo__title">Академия</h4>
      //           </div>
      //           <div className="header-menu is-open">
      //             <button
      //               className="header-menu__btn popup__closeHeader"
      //               type="button"
      //             >
      //               <span />
      //             </button>
      //           </div>
      //         </div>
      //       </div>
      //       <div className="popup__close-container close_auth close_auth_popup"><PopupClose/></div>
      //       <p className="heading heading--2">Авторизация</p>
      //       <p className="auth__to-registr">
      //         Впервые на сайте? {/* FIXME: href to proper route */}
      //         <a className="link link--primary" href="/registration">
      //           Зарегистрироваться
      //         </a>
      //       </p>
      //       <form className="auth__form" action="">
      //         <InputPhone
      //           value={this.state.phone}
      //           data-valid
      //           onChange={value => {
      //             this.setState({ phone: value });
      //           }}
      //           placeholder=""
      //         >
      //           <p className="inp__label">Моб. телефон</p>
      //         </InputPhone>

      //         <label className="inp" htmlFor="passwordInput">
      //           <input
      //             autoComplete="off"
      //             className="inp__field"
      //             type="password"
      //             name="password"
      //             id="passwordInput"
      //             placeholder=" "
      //             value={this.state.password}
      //             onChange={e => {
      //               this.setState({ password: e.target.value });
      //             }}
      //           />
      //           <p className="inp__label">Пароль</p>
      //         </label>
      //         {/* eslint-disable */}
      //         <a
      //           className="link link--primary auth__forget"
      //           onClick={this.onRestorationClick}
      //         >
      //           Забыли пароль?
      //         </a>
      //         {/* eslint-enable */}
      //         <button
      //           className="btn btn--primary"
      //           type="submit"
      //           onClick={this.onAuth}
      //         >
      //           {this.state.spinnerState === spinnerStates.done ? (
      //             'Войти'
      //           ) : (
      //             <React.Fragment>
      //               <div className="invisible">Далее</div>
      //               <Loader
      //                 spinnerState={this.state.spinnerState}
      //                 spinnerPosition={spinnerPositions.absolute}
      //                 className="loader--white"
      //               />
      //             </React.Fragment>
      //           )}
      //         </button>

      //         {this.state.errorMessage !== '' ? (
      //           <div className="error error__popup error__unique--top20 error--center error--red">
      //             {this.state.errorMessage}
      //           </div>
      //         ) : null}
      //       </form>
      //     </div>
      // </React.Fragment>
      <React.Fragment>
        <p className="heading heading--2">Авторизация временно недоступна</p>
      </React.Fragment>
    );
  }
}

// Auth.defaultProps = {
//   onAuthCallback: () => {},
//   onAuthLocation: '/profile',
//   onRegCompliteLocation: '/profile',
// };

// Auth.propTypes = {
//   onAuthCallback: PropTypes.func,
//   onAuthLocation: PropTypes.string,
// };

export default Auth;
